import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { Column, GridRow } from '@shared';
import { IChangeset } from '@shared-data';
import { IPricingItem } from './pricing-item.interface';

class ModifierChangeset implements IChangeset, IPricingItem {
  id: string;
  restaurantId: number;
  restaurantNo: string;
  categoryId?: string;
  status?: string;

  @Column({
    field: 'categoryName',
    title: 'Category',
    order: 0,
    width: 150,
    sortable: true,
    hidden: true,
    filterable: true,
    filterType: 'text',
    align: 'left',
  })
  categoryName?: string;

  @Column({
    field: 'parItemId',
    title: 'Brink ID',
    order: 2,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId: string;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 2,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;

  @Column({
    field: 'itemName',
    title: 'Product',
    order: 1,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string;

  @Column({
    field: 'itemPrice',
    title: 'Current Modifier Price',
    order: 3,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  itemPrice: number;

  @Column({
    field: 'deliveryPrice',
    title: 'Current Modifier Delivery Price',
    order: 4,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  deliveryPrice?: number;

  @Column({
    field: 'newPrice',
    title: 'New Modifier Price',
    order: 3,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    editable: true,
    visibleInQuickView: true,
  })
  newPrice?: number;

  @Column({
    field: 'newDeliveryPrice',
    title: 'New Modifier Delivery Price',
    order: 4,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    editable: true,
    visibleInQuickView: true,
  })
  newDeliveryPrice?: number;

  pricingScheduledDate: Date | null;

  availabilityScheduledDate: Date | null;

  type: string = 'pricing';

  @Column({
    field: 'deliveryUpchargePercentage',
    title: 'Delivery Upcharge %',
    order: 11,
    pipeToken: PercentPipe,
    filterable: true,
    filterType: 'percentage',
    sortable: true,
    width: 90,
    hidden: true,
  })
  deliveryUpchargePercentage?: number;

  @Column({
    field: 'lastModPricingInstore',
    hidden: true,
    title: 'Last Modified Pricing In-Store',
    order: 12,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModPricingInstore?: Date;

  @Column({
    field: 'lastModPricingDelivery',
    hidden: true,
    title: 'Last Modified Pricing Delivery',
    order: 13,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModPricingDelivery?: Date;

  isDeliveryAvailable?: boolean;

  @Column({
    field: 'isActive',
    title: 'Is Active',
    order: 1.5,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: false,
    filterOptions: [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ],
  })
  isActive?: boolean;

  constructor(changeset?: Partial<ModifierChangeset>) {
    this.id = changeset?.id || '';
    this.restaurantId = changeset?.restaurantId ?? 0;
    this.restaurantNo = changeset?.restaurantNo ?? '';
    this.itemName = changeset?.itemName ?? '';
    this.itemPrice = changeset?.itemPrice ?? 0;
    this.deliveryPrice = changeset?.deliveryPrice;
    this.newPrice = changeset?.newPrice;
    this.newDeliveryPrice = changeset?.newDeliveryPrice;
    this.categoryId = changeset?.categoryId;
    this.parItemId = changeset?.parItemId ?? '';
    this.plu = changeset?.plu;
    this.pricingScheduledDate = changeset?.pricingScheduledDate ?? null;
    this.availabilityScheduledDate =
      changeset?.availabilityScheduledDate ?? null;
    this.categoryName = changeset?.categoryName;
    this.deliveryUpchargePercentage = changeset?.deliveryUpchargePercentage;
    this.status = changeset?.status;
    this.lastModPricingInstore = changeset?.lastModPricingInstore;
    this.lastModPricingDelivery = changeset?.lastModPricingDelivery;
    this.isDeliveryAvailable = changeset?.isDeliveryAvailable;
    this.isActive = changeset?.isActive;
  }
}

export class GridRowModifierChangeset extends GridRow(ModifierChangeset) {}
